import { useMemo } from "react";
import { TransportationPerformanceType } from "../../../interface/transportation";
import { RadialChart } from "../../atoms/Charts/RadialChart";
import * as S from "./MainChartContents.style";

interface MainChartContentsProps {
  performanceData?: TransportationPerformanceType;
}

export const MainChartContents = ({
  performanceData,
}: MainChartContentsProps) => {
  // 최초 렌더링시 performanceData가 undefined인 상태로 시작되어 차트 데이터가 0으로 설정됩니다.
  // 이는 performanceData를 가져오는 API 호출이 비동기로 이루어지기 때문입니다.

  const countChartData = useMemo(
    () => ({
      minValue: 0,
      maxValue: 100,
      value: performanceData?.countPercentage ?? 0,
      unit: "전월대비",
    }),
    [performanceData?.countPercentage]
  );

  const amountChartData = useMemo(
    () => ({
      minValue: 0,
      maxValue: 100,
      value: performanceData?.amountPercentage ?? 0,
      unit: "전월대비",
    }),
    [performanceData?.amountPercentage]
  );

  // 해결방법 1: 로딩 상태 추가
  if (!performanceData) {
    return <div>로딩중...</div>;
  }

  return (
    <S.MainChartContents>
      <S.ChartTit>나의 운송실적</S.ChartTit>
      {performanceData && (
        <S.ChartContent>
          <S.Chart>
            <RadialChart
              title="운송건수 실적"
              color="green"
              data={countChartData}
            />
            <S.ChartText>
              <S.TextTit>당월 운송건수</S.TextTit>
              <S.TextValue>{performanceData.currentMonthCount} 건</S.TextValue>
            </S.ChartText>
          </S.Chart>

          <S.Chart>
            <RadialChart
              title="운송요금 실적"
              color="blue"
              data={amountChartData}
            />
            <S.ChartText>
              <S.TextTit>당월 운송요금</S.TextTit>
              <S.TextValue>
                {performanceData.currentMonthAmount.toLocaleString()} 원
              </S.TextValue>
            </S.ChartText>
          </S.Chart>
        </S.ChartContent>
      )}
    </S.MainChartContents>
  );
};
